import usePages from "@whitespace/gatsby-theme-wordpress-basic/src/hooks/usePages";
import { getTreeStructure } from "@whitespace/gatsby-theme-wordpress-basic/src/utils/pageTree";
import { useMemo } from "react";

export default function usePageTree(
  {
    root,
    childrenProp = "items",
    transform = (page, children) => ({ ...page, [childrenProp]: children }),
    includeFrontPage = false,
  } = {},
  deps,
) {
  const allPages = usePages();
  return useMemo(
    () =>
      getTreeStructure(allPages, root, {
        childrenProp,
        transform,
        includeFrontPage,
      }),
    [root, ...deps],
  );
}
